import Vue from 'vue';
import Router from 'vue-router';

import MainLayout from '../layouts/MainLayout';

import store from '../store';

Vue.use(Router);

const guard = (to, from, next) => {
    if (!to.meta.auth) {
        return next();
    }

    if (store.state.user.user === null) {
        if (store.state.user.token !== null && store.state.user.email !== null) {
            // Refresh token/user
            store.dispatch('user/Refresh').then(() => {
                if (store.state.user.user !== null) {
                    return next();
                }
                return next('/login');

            }).catch(() => {
                return next('/login');
            });
        } else {
            return next('/login');
        }
    } else {
        return next();
    }
};

export const routesMap = [
    {
        path: '',
        redirect: '/suppliers',
        component: MainLayout,
        meta: {
            auth: true,
        },
        children: [
            {
                path: '/suppliers',
                component: () => import('@/views/Suppliers/SuppliersView'),
                meta: {auth: true, title: 'Global Suppliers'}
            },
            {
                path: '/products',
                component: () => import('@/views/Products/ProductsView'),
                meta: {auth: true, title: 'Global Products'}
            }
        ]
    },
    {
        path: '/login',
        meta: {
            auth: false,
        },
        component: () => import('@/views/Login'),
        hidden: true
    },
    {
        path: '/404',
        auth: false,
        component: () => import('@/views/404'),
        hidden: true,
        meta: {
            auth: false,
        },
    },
];

const router = new Router({
    mode: 'history',
    routes: routesMap
});

router.beforeEach(guard);

export default router;
